export interface Trade {
  id: number;
  name: string;
  fill_color: string;
  font_color: string;
  display_order: number;
  task_codes: string[];
}

/** Colors for an activity not assigned to any trade. Mirrors the backend
 *  `services/trades` UNASSIGNED_COLOR — keep the two in sync. */
export const TRADE_UNASSIGNED_COLOR = { fill: "#555555", font: "#cccccc" };
